import boy from "../../assets/kangaroo/boyicon.png";
import girl from "../../assets/kangaroo/girlicon.png";
import writing from "../../assets/kangaroo/Writing.png";
import speaking from "../../assets/kangaroo/speaking.png";

export const data = [
  {
    ielts: [
      {
        title: "Listening",
        img: boy,
        duration:
          "Approximately 30 minutes + 10 minutes transfer time (paper-based test)",
        description: `You’ll listen to four recordings of native English speakers. These include conversations and monologues in various contexts—ranging from daily social situations to academic lectures. The test evaluates your ability to understand main ideas, recognize opinions, and follow arguments. You'll answer 40 questions based on what you hear.`,
      },
      {
        title: "Reading",
        img: girl,
        duration: "60 minutes",
        description: `Academic Module: Includes three long, complex texts from books, journals, magazines, and newspapers.

General Training Module: Contains five shorter passages from advertisements, handbooks, notices, and work documents.

This section checks comprehension, detail recognition, logical argument understanding, and identifying writer's attitude.`,
      },
      {
        title: "Writing",
        img: writing,
        duration: "60 minutes",
        description: `Task 1:
- Academic: Describe and interpret visual data (graphs, charts, diagrams).
- General Training: Write a formal or informal letter responding to a situation.

Task 2:
-Write a structured essay expressing an opinion, argument, or solution to a problem.
-This section evaluates clarity, argument structure, vocabulary, and grammar.`,
      },
      {
        title: "Speaking",
        img: speaking,
        duration: "11–14 minutes",
        description: `This face-to-face interview includes three parts:

        1. Introduction & Interview:
Questions about yourself, home, studies, work, and interests.
2. Long Turn:
One-minute preparation; speak up to two minutes on a given topic.
3. Discussion:
In-depth conversation related to Part 2 topic. Assessed on fluency, coherence, pronunciation, vocabulary, and grammar.`,
      },
    ],
  },
];
